import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const ControlDate = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <defs>
          <filter id="a">
            <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.533333 0 0 0 0 0.533333 0 0 0 0 0.533333 0 0 0 1.000000 0"/>
          </filter>
        </defs>
        <g>
          <g transform="translate(1 1)">
            <rect width="7" height="1" x="3.5" y="5.906" rx=".5"/>
            <path d="M10.063 5.906H3.936a.437.437 0 1 0 0 .875h6.126a.437.437 0 1 0 0-.875z"/>
            <rect width="7" height="1" x="3.5" y="9.406" rx=".5"/>
            <path d="M10.063 9.406H3.936a.437.437 0 1 0 0 .875h6.126a.437.437 0 1 0 0-.875z"/>
            <path d="M5.933 1.531H8.068V2.5309999999999997H5.933z"/>
            <path d="M12.25 1.531H10.5v.875h1.75c.483 0 .875.392.875.875v8.75a.875.875 0 0 1-.875.875H1.75a.875.875 0 0 1-.875-.875v-8.75c0-.483.392-.875.875-.875H3.5v-.875H1.75A1.75 1.75 0 0 0 0 3.281v8.75c0 .967.784 1.75 1.75 1.75h10.5a1.75 1.75 0 0 0 1.75-1.75v-8.75a1.75 1.75 0 0 0-1.75-1.75z"/>
            <rect width="1" height="3.5" x="4.296" y=".219" rx=".5"/>
            <path d="M4.734.219a.437.437 0 0 0-.438.437v2.625a.437.437 0 1 0 .875 0V.656A.437.437 0 0 0 4.734.22z"/>
            <rect width="1" height="3.5" x="8.916" y=".219" rx=".5"/>
            <path d="M9.354.219a.437.437 0 0 0-.438.437v2.625a.437.437 0 1 0 .875 0V.656A.437.437 0 0 0 9.354.22z"/>
          </g>
        </g>
      </svg>)} {...props}/>));
export default ControlDate;
